import React from 'react';
import { Alert } from 'react-bootstrap';
import { priceInBoth } from './currencyService';

export function DualPrice({ ves, rate, className = '' }) {
  const usd = priceInBoth(ves, rate)?.usd;
  return (
    <span className={className}>
      {usd != null ? `USD $${usd.toFixed(2)}` : `$${Number(ves).toFixed(2)}`}
      <Alert variant="warning" className="py-1 px-2 mt-1 mb-0 small">
        Equivalente: Bs. {Number(ves).toFixed(2)} (VES)
      </Alert>
    </span>
  );
}